import React, { FunctionComponent } from "react";
import AddIcon from "../../Shared/Icons/AddIcon";
import Button from "../../Shared/Button";
import WarningIcon from "../../Shared/Icons/WarningIcon";
import ChevronUpIcon from "../../Shared/Icons/ChevronUpIcon";

interface ISectionProps {
    title: string;
    children: any;
    isOpen: boolean;
    hasErrors: boolean;
    stripe?: boolean;
    onToggleCollapse(): void;
}
const Section: FunctionComponent<ISectionProps> = ({
    title,
    children,
    stripe,
    onToggleCollapse,
    isOpen,
    hasErrors
}) => {
    return (
        <div className={`my-4 shadow ${stripe ? "bg-blue-200" : "bg-white"} rounded`}>
            <div className={`flex justify-between cursor-pointer p-4`} onClick={onToggleCollapse}>
                <div className="text-2xl my-2 text-blue-800">{title}</div>
                <div className="flex justify-end items-center">
                    {hasErrors && (
                        <div className="text-red-500 text-base mx-4 content-center flex">
                            <div className="flex items-center">
                                <WarningIcon className="w-6 h-6" />
                                <span className="ml-2">Attention Needed.</span>
                            </div>
                        </div>
                    )}
                    <div className="text-2xl text-cerulean-500">
                        <ChevronUpIcon
                            className="w-6 h-6"
                            style={{ transition: ".2s ease", ...(isOpen ? {} : { transform: "rotate(180deg)" }) }}
                        />
                    </div>
                </div>
            </div>
            <div className={`px-4 pb-4 border-t border-gray-400 bg-gray-100 ${isOpen ? "" : "hidden"}`}>{children}</div>
        </div>
    );
};

export default Section;
